import { render, staticRenderFns } from "./testStandard.vue?vue&type=template&id=0ff8fc66&scoped=true"
import script from "./testStandard.vue?vue&type=script&lang=js"
export * from "./testStandard.vue?vue&type=script&lang=js"
import style0 from "./testStandard.vue?vue&type=style&index=0&id=0ff8fc66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff8fc66",
  null
  
)

export default component.exports